// API Configuration
// Change this URL when deploying to production
// Set REACT_APP_API_URL to your backend URL (without /api)
// Example: http://localhost:5000 or https://your-backend.com
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

// Remove /api if it's already in the base URL to avoid duplication
const baseUrl = API_BASE_URL.replace(/\/api\/?$/, "");

export const API_URL = `${baseUrl}/api`;
export const UPLOAD_URL = baseUrl;

export default API_URL;
